const NavbarMenu = [
  {
    id:1,
    title: 'Beranda',
    link: '/'
  },
  {
    id: 2,
    title: 'Keuangan',
    link: '/keuangan'
  },
  {
    id: 3,
    title: 'Data Warga',
    link: '/datapenduduk'
  },
  {
    id:4,
    title: 'Tentang Kami',
    link: '/tentangkami'
  },
]

const NavbarMenuBendahara = [
  {
    id:1,
    title: 'Beranda',
    link: '/'
  },
  {
    id: 2,
    title: 'Data Warga',
    link: '/datapenduduk'
  },
  {
    id:3,
    title: 'Tentang Kami',
    link: '/tentangkami'
  },
  {
    id:4,
    title: 'Dashboard Bendahara',
    link: '/dashboardbendahara/bendahara'
  },
]

const NavbarMenuAdmin = [
  {
    id:1,
    title: 'Beranda',
    link: '/'
  },
  {
    id: 2,
    title: 'Keuangan',
    link: '/keuangan'
  },
  {
    id:3,
    title: 'Tentang Kami',
    link: '/tentangkami'
  },
  {
    id:4,
    title: 'Dashboard Admin',
    link: '/dashboardadmin/admin'
  },
]

export { NavbarMenu, NavbarMenuAdmin, NavbarMenuBendahara };
